var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import Table from './Table';
import PseudoStates from './PseudoStates';
import { authorizedPyInstance as axios } from '../helpers/api';
var requestData = function requestData(_ref, endpoint) {
  var _ref$pageSize = _ref.pageSize,
    pageSize = _ref$pageSize === undefined ? 20 : _ref$pageSize,
    _ref$page = _ref.page,
    page = _ref$page === undefined ? 0 : _ref$page,
    _ref$sorted = _ref.sorted,
    sorted = _ref$sorted === undefined ? [] : _ref$sorted,
    _ref$filtered = _ref.filtered,
    filtered = _ref$filtered === undefined ? [] : _ref$filtered;
  var filters = filtered.map(function (f) {
    return f.id + '=' + f.value;
  });
  var sorts = '&sort=' + sorted.map(function (s) {
    return '' + (s.desc ? '-' : '') + s.id;
  }).join(',');
  if (localStorage.getItem('org')) {
    filters.push('org-uid=' + localStorage.getItem('org'));
  }
  var queryString = encodeURI(filters.join('&') + '&page-size=' + pageSize + '&page=' + (page + 1) + sorts);
  return axios.get('api/' + endpoint + '?' + queryString).then(function (r) {
    return r.data;
  });
};
var CordataStandardTable = function CordataStandardTable(_ref2) {
  var endpoint = _ref2.endpoint,
    props = _objectWithoutProperties(_ref2, ['endpoint']);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    pages = _useState8[0],
    setPages = _useState8[1];
  var fetchData = function fetchData(state) {
    setLoading(true);
    requestData(state, endpoint).then(function (r) {
      setData(r.data);
      setPages(Math.ceil(r.total / state.pageSize));
    }).catch(setError).then(function () {
      return setLoading(false);
    });
  };
  useEffect(function () {
    if (endpoint) {
      fetchData({
        sorted: props.defaultSorted
      }, endpoint);
    }
  }, [endpoint, localStorage.getItem('org')]);
  return !error ? React.createElement(Table, _extends({
    data: data,
    pages: pages,
    loading: loading,
    manual: true,
    filterable: true,
    onFetchData: debounce(fetchData, 750)
  }, props)) : React.createElement(PseudoStates, {
    error: error
  });
};
CordataStandardTable.propTypes = {
  endpoint: PropTypes.string.isRequired,
  defaultSorted: PropTypes.shape()
};
CordataStandardTable.defaultProps = {
  defaultSorted: undefined
};
export default CordataStandardTable;